import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Offers.css';
import { FiYoutube, FiCheck, FiChevronDown } from "react-icons/fi";
import { FaTiktok, FaFacebook, FaCrown, FaStar } from "react-icons/fa";
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion, AnimatePresence } from 'framer-motion';

const offers = [
  {
    title: "BASIC",
    features: [
      "✅ 1-ON-1 GROWTH STRATEGY MEETING",
      "✅ GENERAL GROWTH TIPS",
      "✅ BRAND DESIGN GUIDANCE"
    ]
  },
  {
    title: "ADVANCED",
    features: [
      "✅ 1-ON-1 GROWTH STRATEGY MEETING",
      "✅ PERSONALIZED GROWTH TIPS",
      "✅ BRAND DESIGN GUIDANCE",
      "✅ REAL-TIME ASSISTANCE",
      "✅ INSIGHTS FROM OUR CHANNELS"
    ],
    recommended: true
  },
  {
    title: "PREMIUM",
    features: [
      "✅ 1-ON-1 GROWTH STRATEGY MEETING",
      "✅ PERSONALIZED GROWTH TIPS",
      "✅ BRAND DESIGN GUIDANCE",
      "✅ REAL-TIME ASSISTANCE",
      "✅ INSIGHTS FROM OUR CHANNELS",
      "✅ DEDICATED CONTENT MANAGER",
      "✅ PERSONAL CONTENT PRODUCTION TEAM",
      "✅ MONEY-BACK GUARANTEE IF TARGETS FAIL"
    ]
  }
];

const Offers = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [expandedCards, setExpandedCards] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    brandName: '',
    platform: 'youtube',
    contentStyle: '',
    rawFootage: '',
    volumeOfWork: { fullLengthVideos: '', shorts: '', thumbnails: '' },
    challenges: '',
    communicationMethod: '',
    message: ''
  });

  const toggleCardExpand = (index) => {
    if (expandedCards.includes(index)) {
      setExpandedCards(expandedCards.filter(i => i !== index));
    } else {
      setExpandedCards([...expandedCards, index]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleVolumeChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      volumeOfWork: { ...formData.volumeOfWork, [name]: value }
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const emailData = {
      from_name: formData.name,
      brand_name: formData.brandName,
      platform: formData.platform,
      content_style: formData.contentStyle,
      raw_footage: formData.rawFootage,
      full_length_videos: formData.volumeOfWork.fullLengthVideos,
      shorts: formData.volumeOfWork.shorts,
      thumbnails: formData.volumeOfWork.thumbnails,
      challenges: formData.challenges,
      communication_method: formData.communicationMethod,
      message: formData.message,
      selected_plan: selectedPlan
    };

    emailjs
      .send('service_u208u7h', 'template_3a5zcpj', emailData, 'ZxBHR4GoCaP08_Len')
      .then(
        () => {
          toast.success('Quote request sent successfully!');
          setShowForm(false);
          setFormData({
            name: '',
            brandName: '',
            platform: 'youtube',
            contentStyle: '',
            rawFootage: '',
            volumeOfWork: { fullLengthVideos: '', shorts: '', thumbnails: '' },
            challenges: '',
            communicationMethod: '',
            message: '',
          });
          setSelectedPlan(null);
        },
        () => {
          toast.error('Error sending quote request. Please try again.');
        }
      );
  };

  const openFormWithPlan = (planTitle) => {
    setSelectedPlan(planTitle);
    setShowForm(true);
  };

  return (
    <div className="offers-section">
      <div className="container">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="section-header"
        >
          <h2>Choose Your Growth Plan</h2>
          <p className="subtitle">Select the package that matches your creator ambitions</p>
          <div className="divider"></div>
        </motion.div>

        <div className="offers-grid">
          {offers.map((offer, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`offer-card ${offer.recommended ? "recommended" : ""}`}
            >
              {offer.recommended && (
                <div className="recommended-badge">
                  <FaCrown className="crown-icon" />
                  <span>RECOMMENDED</span>
                </div>
              )}
              
              <div className="card-header">
                <h3>{offer.title}</h3>
                <div className="price">{offer.title === "BASIC" ? "Perfect for starters" : 
                                       offer.title === "ADVANCED" ? "Ideal for growing channels" : 
                                       "For serious creators & brands"}</div>
              </div>

              <div className={`card-body ${expandedCards.includes(index) ? 'expanded' : ''}`}>
                <div className="features">
                  <ul>
                    {offer.features.map((feature, i) => (
                      <li key={i}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="card-footer">
                <button 
                  className="toggle-details"
                  onClick={() => toggleCardExpand(index)}
                >
                  {expandedCards.includes(index) ? 'Show Less' : 'Show Details'}
                  <FiChevronDown className={`chevron ${expandedCards.includes(index) ? 'up' : 'down'}`} />
                </button>
                
                <button 
                  className="select-plan"
                  onClick={() => openFormWithPlan(offer.title)}
                >
                  Select {offer.title}
                </button>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="testimonial-section">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="star-icon" />
            ))}
          </div>
          <p className="testimonial-text">
            "The Advanced plan transformed my channel from 10k to 100k subscribers in just 3 months. 
            The personalized strategy sessions were game-changing!"
          </p>
          <p className="testimonial-author">- Sarah K., Lifestyle Creator</p>
        </div>

        <AnimatePresence>
          {showForm && (
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="custom-quote-form-overlay"
            >
              <motion.div 
                initial={{ scale: 0.9, y: 50 }}
                animate={{ scale: 1, y: 0 }}
                exit={{ scale: 0.9, y: 50 }}
                className="custom-quote-form-container"
              >
                <form className="custom-quote-form" onSubmit={sendEmail}>
                  <div className="form-header">
                    <h2>Get Started with {selectedPlan}</h2>
                    <p>Fill out this form and we'll get back to you within 24 hours</p>
                    <button 
                      type="button" 
                      className="close-form" 
                      onClick={() => {
                        setShowForm(false);
                        setSelectedPlan(null);
                      }}
                    >
                      &times;
                    </button>
                  </div>

                  <div className="form-body">
                    <div className="form-row">
                      <div className="form-field">
                        <label>Full Name</label>
                        <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
                      </div>
                      <div className="form-field">
                        <label>Brand Name</label>
                        <input type="text" name="brandName" value={formData.brandName} onChange={handleInputChange} required />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-field platform-field">
                        <label>Platform(s) for Collaboration</label>
                        <div className="select-wrapper">
                          <select
                            name="platform"
                            value={formData.platform}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="youtube">
                              <FiYoutube className="platform-icon" /> YouTube
                            </option>
                            <option value="youtubeshorts">YouTube Shorts</option>
                            <option value="tiktok">
                              <FaTiktok className="platform-icon" /> TikTok
                            </option>
                            <option value="facebook">
                              <FaFacebook className="platform-icon" /> Facebook
                            </option>
                            <option value="other">Other</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-field">
                        <label>Content Style/Theme</label>
                        <input type="text" name="contentStyle" value={formData.contentStyle} onChange={handleInputChange} required />
                      </div>
                    </div>

                    <div className="form-field">
                      <label>Raw Footage Details</label>
                      <textarea name="rawFootage" value={formData.rawFootage} onChange={handleInputChange} required />
                    </div>

                    <div className="form-field">
                      <label>Volume of Work</label>
                      <div className="volume-inputs">
                        <div className="volume-input">
                          <label>Full-length videos/month</label>
                          <input type="number" name="fullLengthVideos" value={formData.volumeOfWork.fullLengthVideos} onChange={handleVolumeChange} required />
                        </div>
                        <div className="volume-input">
                          <label>Shorts/month</label>
                          <input type="number" name="shorts" value={formData.volumeOfWork.shorts} onChange={handleVolumeChange} required />
                        </div>
                        <div className="volume-input">
                          <label>Thumbnails/month</label>
                          <input type="number" name="thumbnails" value={formData.volumeOfWork.thumbnails} onChange={handleVolumeChange} required />
                        </div>
                      </div>
                    </div>

                    <div className="form-field">
                      <label>Current Challenges</label>
                      <textarea name="challenges" value={formData.challenges} onChange={handleInputChange} required />
                    </div>

                    <div className="form-field">
                      <label>Preferred Communication Method</label>
                      <input type="text" name="communicationMethod" value={formData.communicationMethod} onChange={handleInputChange} required />
                    </div>

                    <div className="form-field">
                      <label>Additional Message</label>
                      <textarea name="message" value={formData.message} onChange={handleInputChange} />
                    </div>
                  </div>

                  <div className="form-footer">
                    <button type="submit" className="submit-form">
                      Submit Request
                    </button>
                    <p className="form-note">
                      By submitting, you agree to our <a href="/privacy">Privacy Policy</a>. 
                      We'll never spam you or sell your information.
                    </p>
                  </div>
                </form>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <ToastContainer position="bottom-right" autoClose={5000} />
    </div>
  );
};

export default Offers;